import styled from 'styled-components'

import { colors } from 'app/theme/colors'

export const MessageWrapper = styled.div`
  margin-right: 100px;
  font-style: oblique;
  font-weight: 600;
`

export const ProgramCapacityIndicator = styled.div`
  font-size: 1.125rem;
  font-weight: bold;
  color: ${(props) => (props.isFull ? colors.ohRed : colors.ohBlack)};
`

export const InvalidDOBLink = styled.a`
  margin-left: 5px;
`
